<template>
  <div class="wrapper">
    <div class="breadcrumb">{{$t("about.history.breadcrumb")}}</div>
    <div class="container common" @mouseenter="on_enter" @mouseleave="on_leave">
      <!-- swiperThumbs -->
      <swiper :options="swiperOptionThumbs" class="gallery-thumbs" ref="swiperThumbs">
        <swiper-slide v-for="item in dataList" :key="item.date">{{item.date}}</swiper-slide>
        <div class="swiper-button-next swiper-btn" slot="button-next"></div>
        <div class="swiper-button-prev swiper-btn" slot="button-prev"></div>
      </swiper>
      <!-- swiperMain -->
      <swiper :options="swiperOptionMain" class="gallery-main swiper-nest" ref="swiperOptionMain">
        <swiper-slide v-for="lists in dataList" :key="lists.id">
          <div class="items">
            <div class="item-header">
              <div class="title">{{getLang === 'zh' ? lists.title : lists.fantiTitle}}</div>
              <p class="text" v-html="getLang === 'zh' ? lists.text : lists.fantiText"></p>
            </div>
            <div class="item-body">
              <swiper :options="swiperOptionIn" ref="swiperOptionIn" class="gallery-main-items swiper-nest">
                <swiper-slide v-for="list in lists.img" :key="list.id">
                  <div class="insideImg"><img :src="list.url"/></div>
                  <div class="text" v-html="getLang === 'zh' ? list.text : list.fantiText"></div>
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
                <div class="swiper-button-prev swiper-btn" slot="button-prev"></div>
                <div class="swiper-button-next swiper-btn" slot="button-next"></div>
              </swiper>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
export default {
  name: 'doubleSwiper',
  data () {
    return {
      dataList: [
        {
          date: '2007',
          title: '2007年',
          text: '新福港地产正式在深圳、广州挂牌成立，开展国内房地产业务。',
          fantiTitle: '2007年',
          fantiText: '新福港地産正式在深圳、廣州掛牌成立，開展國內房地産業務。',
          img: [
            {
              text: `请添加图片描述`,
              fantiText: '請添加圖片描述',
              url: 'static/images/about/history/2007_01.jpg'
            },
            {
              text: `请添加图片描述`,
              fantiText: '請添加圖片描述',
              url: 'static/images/about/history/2007_02.jpg'
            }
          ]
        },
        {
          date: '2008',
          title: '2008年',
          text: '广州力迅·原筑落成',
          fantiTitle: '2008年',
          fantiText: '廣州力迅·原築落成',
          img: [
            {
              text: `请添加图片描述`,
              fantiText: '請添加圖片描述',
              url: 'static/images/about/history/2008_01.png'
            }
          ]
        },
        {
          date: '2009',
          title: '2009年',
          text: '1.珠海映晖湾落成　2.苏州枫桦紫园落成　3.苏州未名园落成　4.成都领筑落成',
          fantiTitle: '2009年',
          fantiText: '1.珠海映暉灣落成　2.蘇州楓樺紫園落成　3.蘇州未名園落成　4.成都領築落成',
          img: [
            {
              text: `珠海映晖湾`,
              fantiText: '珠海映暉灣',
              url: 'static/images/about/history/2009_01.jpg'
            },
            {
              text: `苏州枫桦紫园`,
              fantiText: '蘇州楓樺紫園',
              url: 'static/images/about/history/2009_02.jpg'
            },
            {
              text: `苏州未名园`,
              fantiText: '蘇州未名園',
              url: 'static/images/about/history/2009_03.jpg'
            },
            {
              text: `成都领筑`,
              fantiText: '成都領築',
              url: 'static/images/about/history/2009_04.jpg'
            }
          ]
        },
        {
          date: '2010',
          title: '2010年',
          text: '顺德新红棉大厦落成',
          fantiTitle: '2010年',
          fantiText: '順德新紅棉大廈落成',
          img: [
            {
              text: `请添加图片描述`,
              fantiText: '請添加圖片描述',
              url: 'static/images/about/history/2010_01.jpg'
            }
          ]
        },
        {
          date: '2011',
          title: '2011年',
          text: '广州力迅 · T落成',
          fantiTitle: '2011年',
          fantiText: '廣州力迅 · T落成',
          img: [
            {
              text: `请添加图片描述`,
              fantiText: '請添加圖片描述',
              url: 'static/images/about/history/2011_01.jpg'
            },
            {
              text: `请添加图片描述`,
              fantiText: '請添加圖片描述',
              url: 'static/images/about/history/2011_02.jpg'
            },
            {
              text: `请添加图片描述`,
              fantiText: '請添加圖片描述',
              url: 'static/images/about/history/2011_03.jpg'
            },
            {
              text: `请添加图片描述`,
              fantiText: '請添加圖片描述',
              url: 'static/images/about/history/2011_04.jpg'
            }
          ]
        },
        {
          date: '2012',
          title: '2012年',
          text: '江门峻廷湾落成',
          fantiTitle: '2012年',
          fantiText: '江門峻廷灣落成',
          img: [
            {
              text: `请添加图片描述`,
              fantiText: '請添加圖片描述',
              url: 'static/images/about/history/2012_01.jpg'
            },
            {
              text: `请添加图片描述`,
              fantiText: '請添加圖片描述',
              url: 'static/images/about/history/2012_02.jpg'
            }
          ]
        },
        {
          date: '2013',
          title: '2013年',
          text: '签约丽江新福港旅游度假村地块',
          fantiTitle: '2013年',
          fantiText: '簽約麗江新福港旅遊度假村地塊',
          img: [
            {
              text: `请添加图片描述`,
              fantiText: '請添加圖片描述',
              url: 'static/images/about/history/2013_01.jpg'
            }
          ]
        },
        {
          date: '2014',
          title: '2014年',
          text: '广州新福港鼎峰落成',
          fantiTitle: '2014年',
          fantiText: '廣州新福港鼎峰落成',
          img: [
            {
              text: `请添加图片描述`,
              fantiText: '請添加圖片描述',
              url: 'static/images/about/history/2014_01.jpg'
            },
            {
              text: `请添加图片描述`,
              fantiText: '請添加圖片描述',
              url: 'static/images/about/history/2014_02.jpg'
            },
            {
              text: `请添加图片描述`,
              fantiText: '請添加圖片描述',
              url: 'static/images/about/history/2014_03.jpg'
            },
            {
              text: `请添加图片描述`,
              fantiText: '請添加圖片描述',
              url: 'static/images/about/history/2014_04.jpg'
            }
          ]
        },
        {
          date: '2015',
          title: '2015年',
          text: '成都御青城度假别墅落成',
          fantiTitle: '2015年',
          fantiText: '成都御青城度假別墅落成',
          img: [
            {
              text: `请添加图片描述`,
              fantiText: '請添加圖片描述',
              url: 'static/images/about/history/2015_01.jpg'
            },
            {
              text: `请添加图片描述`,
              fantiText: '請添加圖片描述',
              url: 'static/images/about/history/2015_02.jpg'
            }
          ]
        },
        {
          date: '2017',
          title: '2017年',
          text: '1.佛山新福港鼎峰落成　2.佛山新DNA商场落成',
          fantiTitle: '2017年',
          fantiText: '1.佛山新福港鼎峰落成　2.佛山新DNA商場落成',
          img: [
            {
              text: `佛山新福港鼎峰`,
              fantiText: '佛山新福港鼎峰',
              url: 'static/images/about/history/2017_01.jpg'
            },
            {
              text: `佛山新福港鼎峰`,
              fantiText: '佛山新福港鼎峰',
              url: 'static/images/about/history/2017_02.png'
            },
            {
              text: `佛山新DNA商场`,
              fantiText: '佛山新DNA商場',
              url: 'static/images/about/history/2017_03.png'
            },
            {
              text: `佛山新DNA商场`,
              fantiText: '佛山新DNA商場',
              url: 'static/images/about/history/2017_04.png'
            }
          ]
        },
        {
          date: '2018',
          title: '2018年',
          text: '广州新福港鼎荟正在启动...',
          fantiTitle: '2018年',
          fantiText: '廣州新福港鼎薈正在啟動...',
          img: [
            {
              text: `请添加图片描述`,
              fantiText: '請添加圖片描述',
              url: 'static/images/about/history/2018_01.jpg'
            },
            {
              text: `请添加图片描述`,
              fantiText: '請添加圖片描述',
              url: 'static/images/about/history/2018_02.jpg'
            },
            {
              text: `请添加图片描述`,
              fantiText: '請添加圖片描述',
              url: 'static/images/about/history/2018_03.jpg'
            }
          ]
        }
      ],
      // notNextTick: true,
      swiperOptionIn: {
        autoHeight: true,
        autoplay: false,
        /* autoplay: {
          delay: 2500,
          stopOnLastSlide: false,
          disableOnInteraction: true
        }, */
        effect: 'fade',
        loop: false,
        slidesPerView: 'auto',
        loopedSlides: 8,
        mousewheel: true,
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      swiperOptionMain: {
        effect: 'fade'
      },
      swiperOptionThumbs: {
        autoplay: {
          delay: 5000,
          stopOnLastSlide: false,
          disableOnInteraction: true
        },
        // autoplay: true,
        centeredSlides: true,
        slidesPerView: 6,
        touchRatio: 0.2,
        slideToClickedSlide: true,
        mousewheel: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        breakpoints: {
          1920: {
            slidesPerView: 6
          },
          1440: {
            slidesPerView: 4
          },
          1024: {
            slidesPerView: 3
          },
          768: {
            slidesPerView: 2
          }
        }
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      const swiperOptionMain = this.$refs.swiperOptionMain.swiper
      const swiperThumbs = this.$refs.swiperThumbs.swiper
      swiperOptionMain.controller.control = swiperThumbs
      swiperThumbs.controller.control = swiperOptionMain
    })
    window.onresize = function temp () {
      /* let t1 = `${document.documentElement.clientHeight}px`
      console.log(t1) */
    }
  },
  computed: {
    getLang () {
      return this.$store.state.lang
    },
    mySwiper () {
      return this.$refs.swiperThumbs.swiper
    }
  },
  methods: {
    on_enter () {
      this.mySwiper.autoplay.stop()
    },
    on_leave () {
      this.mySwiper.autoplay.start()
    }
  }
}
</script>

<style scoped lang="stylus">
  @import "~styles/varibles"
  @import "~styles/mixins"
  .wrapper
    width 78%
    font-size 15px
    line-height 26px
    .breadcrumb:before
      afterTop()
      width 4px
      height 60%
      top 20%
      background $navBgColor2
    .breadcrumb:after
      afterBottom()
      borderBottom()
      width 100%
      opacity 0.2
    .breadcrumb
      cn()
      font-size 24px
      font-weight bold
      padding 5px 0 5px 20px
      position relative
      margin-bottom 45px
  .gallery-thumbs:after
    position absolute
    bottom 2px
    left 0
    content ''
    width 100%
    height 1px
    background #ccc
  .gallery-thumbs
    height 60px!important
    box-sizing border-box
    position relative
    .swiper-slide
      text-align center
      display flex
      justify-content center
      align-items center
      opacity 0.4
      font-size 20px
      line-height 45px
      font-family "Source Han Sans CN Normal", Arial, "Helvetica Neue", Helvetica, sans-serif
    .swiper-slide-active
      opacity 1
      box-sizing border-box
      font-size 32px
      line-height 38px
      font-weight bold
      color #000
      border-bottom 5px solid #b0d600
    .swiper-btn
      top 65%!important
      width 50px!important
      height 35px!important
      background-repeat no-repeat
      background-size auto!important
      background-color #fff
    .swiper-button-prev
      left 0
      background-image url("~assets/home/arrow-left.png")!important
      background-position center left
    .swiper-button-next
      right 0
      background-image url("~assets/home/arrow-right.png")!important
      background-position center right
  .gallery-main
    width: 100%
    margin-top 27px
    .items
      background #FFFFFF
      .item-header
        box-sizing border-box
        padding-right 40px
        font-weight bold
      .title
        cn()
        font-size 20px
      .item-body
        margin-top 25px
      .item-footer
        margin-top 25px
        box-sizing border-box
        padding 0 20px
  .gallery-main-items:hover
    .swiper-btn,.swiper-pagination
      opacity 1
  .gallery-main-items
    .swiper-pagination
      opacity 0
      transition opacity 1s
      top 35px!important
    .swiper-btn
      background rgba(0,0,0,0.3)
      background-repeat no-repeat
      background-size cover
      border-radius 3px
      padding 4px 4px
      opacity 0
      transition opacity 1s
      top 50px
    .swiper-button-prev
      background-image url("~~assets/common/width-64-left.png")
      background-position center left
    .swiper-button-next
      background-image url("~~assets/common/width-64-right.png")
      background-position center right
    .insideImg
      text-align center
      img
        width 100%
    .text
      margin-top 15px
      background #FFF
</style>



// WEBPACK FOOTER //
// src/pages/about/components/doubleSwiper.vue